import { useDeleteTaskMutation } from 'app/api';
import { selectSelectedEnvId } from 'app/containers/HiikoEnv/slice/selectors';
import { RouteConstants } from 'app/routes';
import { useSelector } from 'react-redux';
import { generatePath, useHistory } from 'react-router-dom';
import { showDeleteTaskSuccessNotification } from 'utils/notifications';

export const useDeleteTask = ({ taskId }: { taskId?: number }) => {
  const envId = useSelector(selectSelectedEnvId) as number;
  const history = useHistory();

  const [
    deleteTask,
    { isLoading: isTaskDeleteLoading },
  ] = useDeleteTaskMutation();

  const onDelete = async () => {
    if (isTaskDeleteLoading || !envId || !taskId) {
      return;
    }

    await deleteTask({ envId, taskId }).unwrap();

    history.push(generatePath(RouteConstants.task.list, { envId }));

    showDeleteTaskSuccessNotification();
  };

  return { onDelete, isTaskDeleteLoading };
};
